<div class="led-wrapper">
  <p *ngIf="!entityId" class="no-selection">Select a legal entity to view details.</p>
  <div *ngIf="entityId" class="led-content">
    <app-az-tabs
      [tabs]="tabs"
      [activeTabId]="activeTabId()"
      (activeTabChange)="onTabChange($event)"
    >
      <div class="tab-content overlay-scroll--custom" scrollActivity [scrollActivityCustom]="true">
        <app-legal-entity-information *ngIf="activeTabId() === 'info'" [entityId]="entityId" />
        <app-legal-entity-documents *ngIf="activeTabId() === 'documents'" [entityId]="entityId" />
      </div>
    </app-az-tabs>
  </div>
</div>
